'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.SearchCriteria', 'AVRO.Common.Ranges', 'AVRO.Common.Moment'];
module.exports = angular.module('AVRO.FlightAnalysis.Common', dependencies).service('FlightSearchCriteriaFilterBuilderService', require('./services/FlightSearchCriteriaFilterBuilderService')).service('FlightComponentVisibilityManagerService', require('./services/FlightComponentVisibilityManagerService'));